import { TableRow, TableCell, Box } from "@mui/material";
import { TableSeparatorProps } from "../types";

const TableSeparator: React.FC<TableSeparatorProps> = ({
  text,
  backgroundColor,
  showCheckbox = false,
}) => {
  return (
    <TableRow>
      <Box sx={{ display: "flex", width: "100%" }}>
        {showCheckbox && (
          <TableCell
            sx={{
              left: 0,
              zIndex: 2,
              backgroundColor: "background.white",
              boxShadow: "2px 0 2px 0 rgba(0, 0, 0, 0.2)",
              width: 50,
              border: "none",
              position: "sticky",
            }}
          />
        )}
        <TableCell
          sx={{
            height: "28px",
            backgroundColor,
            color: "#606A7A",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "20px",
            letterSpacing: "0%",
            verticalAlign: "middle",
            paddingLeft: "20px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            right: 0,
          }}
        >
          {text}
        </TableCell>
      </Box>
    </TableRow>
  );
};

export default TableSeparator;
